export default __webpack_public_path__ + "static/media/noexpl_04_DE.2d13af93.png";